import { FC } from "react";
import { Box, IconButton } from "@mui/material";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import { BrokersGridMenu } from "../brokers/menu";
import { BrokerMenu } from "../broker/menu";
import { RequestNewBrokerMenu } from "../requestNew/menu";
import { MyBrokerRequestsMenu } from "../myRequests/menu";

type Props = {};

export const BrokersMenu: FC<Props> = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isOverview = /^\/brokers\/?$/.test(location.pathname);

  const nav = () => (isOverview ? navigate("/home") : navigate("/brokers"));

  return (
    <Box display="flex" width="100%">
      <IconButton onClick={nav} sx={{ color: "secondary.main" }}>
        <ArrowBackIcon />
      </IconButton>
      <Box display="flex" alignItems="center" width="100%">
        <Routes>
          <Route path="broker/:id/*" element={<BrokerMenu />} />
          <Route path="request-new" element={<RequestNewBrokerMenu />} />
          <Route path="my-requests" element={<MyBrokerRequestsMenu />} />
          <Route path="*" element={<BrokersGridMenu />} />
        </Routes>
      </Box>
    </Box>
  );
};
